module.exports = __webpack_public_path__ + "img/w3_spinner_grey.bf3df66f.png";